import React,{useCallback,useEffect, useState} from 'react';
import {Tooltip,Typography,Grid,Box,useTheme, Button} from '@material-ui/core';
import Alert from '@material-ui/lab/Alert';
import useStyles from "./styles";
import { getMuiTheme } from "./styles";
import { MuiThemeProvider } from "@material-ui/core/styles";
import {pathOr,clone} from "ramda";
import MUIDataTable from "mui-datatables";

import { getInboundOutboundEmails, getEditInboundOutboundEmail,deleteInboundOutboundEmail} from '../../../../../store/actions/module.actions';
import { toast } from "react-toastify";
import {Skeleton,Alert as ConfirmBox} from "../../../../../components";
import SkeletonShell from "../../../../../components/Skeleton/index";
import EditIcon from '@material-ui/icons/Edit';
import DeleteIcon from '@material-ui/icons/Delete';
import { TableCell,IconButton } from '@material-ui/core';
import Checkbox from '@material-ui/core/Checkbox';


export default function List(props) {
  const classes = useStyles();
  const currentTheme = useTheme();
  // const [editValues, setEditValues]=useState({email_user:''});
  // const [openImapConfig, setOpenImapConfig] = useState(false);
  const [inboundList, setInboundList] = useState([]);
  const [outboundList, setOutboundList] = useState([]);
  const [loading, setLoading] = useState(true);
  const [alertVisible, setAlertVisibility] = useState(false);
  const [recordId, setRecordId] = useState(null);

  //const dispatch = useDispatch();
  


  const getListViewData = useCallback(async () => {
      try {
        const res = await getInboundOutboundEmails();
        setLoading(true);
        if (res.ok) {
          setInboundList(pathOr('', ['data', 'inbound_account_list'], res.data));
          setOutboundList(pathOr('', ['data', 'outbound_account_list'], res.data));
          props.setOutboundList(pathOr('', ['data', 'outbound_account_list'], res.data));
        }
        setLoading(false);
      } catch (ex) {
        toast("Something went wrong!");
      }
   
  }, []);

	useEffect(
		() => {getListViewData()},
		[getListViewData]
	);


  

  const [columnsInbound, setColumnsInbound] = useState([
        {
          label: 'Mail Account Name',
          name: 'name',
          type: 'varchar'
        },
        {
          label: 'Mail Server Address',
          name: 'server_url',
          type: 'varchar'
        },
        {
          label: 'Active',
          name: 'is_active',
          type: 'name'
        },
        {
          label: 'Default',
          name: 'is_default',
          type: 'varchar'
        },
        {
          label: 'Type',
          name: 'type',
          type: 'varchar'
        },
        {
          label: 'Action',
          name: 'action',
          type: 'varchar'
        }

      ]);
      const [columnsOutbound, setColumnsOutbound] = useState([
        {
          label: 'Mail Account Name',
          name: 'name',
          type: 'varchar'
        },
        {
          label: 'Mail Server Address',
          name: 'mail_smtpserver',
          type: 'varchar'
        },
        {
          label: 'Type',
          name: 'type',
          type: 'varchar'
        },
        {
          label: 'Action',
          name: 'action',
          type: 'varchar'
        }

      ]);
      


      let columnsInb = columnsInbound.map((it) => {
    
        if (it.name === "action") {
             return {
               name: "Actions",
               options: {
                 filter: false,
                 customHeadRender: (columnMeta, updateDirection) => (
                   <TableCell
                     variant='head'
                     align="right"
                     className={classes.headRightBtn}>
                     Action
                   </TableCell>
                 ),
                 customBodyRender: (value, tableMeta, updateValue) => {
                 
                  const rowData = inboundList[tableMeta["rowIndex"]].id;
                  return (
                    !inboundList[tableMeta["rowIndex"]].is_group?
                    <div className={classes.rightBtn}>
                      <Tooltip title="Edit">
                      <IconButton size="small" aria-label="edit"
                       onClick={() =>handleEditBtn('inbound',rowData)}>
                        <EditIcon />
                      </IconButton>
                      </Tooltip>
                      <Tooltip title="Delete">
                       <IconButton size="small" aria-label="delete"
                         onClick={() => confirmDeletion('inbound',rowData)}>
                         <DeleteIcon />
                       </IconButton>
                       </Tooltip>
                      </div>
                   :null);
                 },
               },
             };
           }else         if (it.name === "type") {
            return {
              name: "Type",
              options: {
                filter: false,
                customHeadRender: (columnMeta, updateDirection) => (
                  <TableCell
                    variant='head'
                    align="right"
                    className={classes.headRightBtn}>
                    Type
                  </TableCell>
                ),
                customBodyRender: (value, tableMeta, updateValue) => {
                
                 return (
                   <div className={classes.rightBtn}>
                                        {inboundList[tableMeta["rowIndex"]].is_group?
                   "Group":"Personal"}

                     </div>
                  );
                },
              },
            };
          }else    if (it.name === "is_active") {
            return {
              name: "Active",
              options: {
                filter: false,
                customHeadRender: (columnMeta, updateDirection) => (
                  <TableCell
                    variant='head'
                    align="right"
                    className={classes.headRightBtn}>
                    Active
                  </TableCell>
                ),
                customBodyRender: (value, tableMeta, updateValue) => {
                let isActive = inboundList[tableMeta["rowIndex"]].is_active;
                 return (
                   <div className={classes.rightBtn}>
                     {isActive?
                   <Checkbox disabled checked inputProps={{ 'aria-label': 'disabled checked checkbox' }} />:
                   <Checkbox disabled  inputProps={{ 'aria-label': 'disabled checkbox' }} />
                     }
                   </div>
                  );
                },
              },
            };
          }else     if (it.name === "is_default") {
            return {
              name: "Default",
              options: {
                filter: false,
                customHeadRender: (columnMeta, updateDirection) => (
                  <TableCell
                    variant='head'
                    align="right"
                    className={classes.headRightBtn}>
                    Default
                  </TableCell>
                ),
                customBodyRender: (value, tableMeta, updateValue) => {
                  let isDefault = inboundList[tableMeta["rowIndex"]].is_default;
                 return (
                   <div className={classes.rightBtn}>
                     {isDefault?
                   <Checkbox disabled checked inputProps={{ 'aria-label': 'disabled checked checkbox' }} />:
                   <Checkbox disabled  inputProps={{ 'aria-label': 'disabled checkbox' }} />
                     }

                   </div>
                  );
                },
              },
            };
          }       
           return it;
         });
         let columnsOut = columnsOutbound.map((it) => {
    
          if (it.name === "action") {
               return {
                 name: "Actions",
                 options: {
                   filter: false,
                   customHeadRender: (columnMeta, updateDirection) => (
                     <TableCell
                       variant='head'
                       align="right"
                       className={classes.headRightBtn}>
                       Action
                     </TableCell>
                   ),
                   customBodyRender: (value, tableMeta, updateValue) => {
                   const rowData = outboundList[tableMeta["rowIndex"]].id;
                     return (
                      outboundList[tableMeta["rowIndex"]]['type']!=='system'?
                       <div className={classes.rightBtn}>
                         <Tooltip title="Edit">
                         <IconButton size="small" aria-label="edit"
                          onClick={() =>handleEditBtn('outbound',rowData)}>
                           <EditIcon />
                         </IconButton>
                         </Tooltip>
                         <Tooltip title="Delete">
                         <IconButton size="small" aria-label="delete"
                           onClick={() => confirmDeletion('outbound',rowData)}>
                           <DeleteIcon />
                         </IconButton>
                         </Tooltip>
                        </div>:null
                     );
                   },
                 },
               };
             } 
             return it;
           });
  const handleAddBtn=(type)=>{
    props.setFields({});
    props.setErrors({});
    let title="";
    if(type==='inbound') title="Add New Inboud Email Account";
    if(type==='outbound') title="Add New Outboud Email Account";
    props.setModal({type:type,title:title});
  }

  const handleEditBtn=async (type,row)=>{
    props.setFields({});
    props.setErrors({});
    let title="";
    if(type==='inbound') title="Edit Inboud Email Account";
    if(type==='outbound') title="Edit Outboud Email Account";

    try {
      const res = await getEditInboundOutboundEmail(type,row);
      setLoading(true);
      if (res.ok) {
        let rowData=res.data.data;
        // console.log("resData",rowData)
        props.setModal({type:type,title:title,rowData});
      }
      setLoading(false);
    } catch (ex) {
      toast("Something went wrong!");
    }
  }
  const confirmDeletion = (type,id) => {
		setAlertVisibility(true);
		setRecordId({type:type,id:id});
	};
  const handleDeleteBtn = async () => {
		setAlertVisibility(!alertVisible);
		try {
      const res = await deleteInboundOutboundEmail(recordId.type, recordId.id);
      //console.log("res",res);
      if(res && res.ok && res.data && res.data.data && res.data.data.id)
      {
        //console.log("res ok",res);
        let data = recordId.type==='inbound'?clone(inboundList):clone(outboundList);
        setInboundList(data.filter(el=>el.id !== recordId.id));
        toast("Email account deleted successfully!");
      }else{
        toast('Something went wrong!');  
      }
		} catch (e) {
			toast('Something went wrong!');
		}
	};
  
  if (loading) {
		return <div style={{height:'500px'}}><Skeleton /></div>;
	}
  return (
    <MuiThemeProvider theme={getMuiTheme(currentTheme)}>

        <Box>
          <MUIDataTable
            title={
              <Typography variant="h6" style={{fontSize:"1.25rem"}}>
                Inbound Email Accounts
              </Typography>
            }
            //data={data.map((it) => it.attributes)}
            data={inboundList}
            columns={columnsInb}
            options={{
              filter: false,
              sort:false,
              download: false,
              print: false,
              viewColumns: false,
              selectableRows: false,            
              page: false,            
              search: false,
              rowsPerPage: false,
              fixedHeader: true,
              serverSide: true,
              rowsPerPageOptions: false,           
              textLabels: {
                body: {
                  noMatch: loading ?  <SkeletonShell layout='listView' display /> : <div style={{ padding: "10px 5px 10px 5px" }}><Alert variant="outlined" severity="warning">
                    No results found!
                </Alert></div>,
                },
              },
              customFooter: (count,page,rowsPerPage,changeRowsPerPage,changePage) => {return <Button size="small" className={classes.addBtn} variant="contained" color="primary" onClick={()=>handleAddBtn("inbound")}>Add New</Button>;}
            }}
          />
        </Box>
        <Box>
          <MUIDataTable
            title={
              <Typography variant="h6" style={{fontSize:"1.25rem"}}>
                Outbound Email Accounts
              </Typography>
            }
            //data={data.map((it) => it.attributes)}
            data={outboundList}
            columns={columnsOut}
            options={{
              filter: false,
              sort:false,
              download: false,
              print: false,
              viewColumns: false,
              selectableRows: false,            
              page: false,            
              search: false,
              rowsPerPage: false,
              fixedHeader: true,
              serverSide: true,
              rowsPerPageOptions: false,           
              textLabels: {
                body: {
                  noMatch: loading ? <SkeletonShell layout='listView' display />  : <div style={{ padding: "10px 5px 10px 5px" }}><Alert variant="outlined" severity="warning">
                    No results found!
                </Alert></div>,
                },
              },
              customFooter: (count,page,rowsPerPage,changeRowsPerPage,changePage) => {return <Button size="small" className={classes.addBtn} variant="contained" color="primary" onClick={()=>handleAddBtn("outbound")}>Add New</Button>}
            }}
          />
        </Box>
        <ConfirmBox
						title="Delete Record"
						msg="Are you sure you want to delete this record?"
						open={alertVisible}
						agreeText={"Yes"}
						disagreeText={"No"}
						handleClose={() => setAlertVisibility(!alertVisible)}
						onAgree={handleDeleteBtn}
					/>
      </MuiThemeProvider>
  );
}
